import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';

const ProtectedRoute = ({ permissions: permissionsProps, redirectPath = '/', children }) => {
  const userStatus = useSelector((state) => state.securityNew.userStatus);

  const permissions = useMemo(
    () => (Array.isArray(permissionsProps) ? permissionsProps : [permissionsProps]),
    [permissionsProps],
  );

  const isAllowed = useMemo(
    () => permissions.some((element) => userStatus.includes(element)),
    [permissions, userStatus],
  );

  if (!isAllowed) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
